import React from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import InvoicePDF from "./InvoicePDF";

const data = {
  emisor: "—",
  emisorRuc: "—",
  emisorDv: "—",
  emisorDireccion: "—",

  clienteNombre: "Invitado",
  clienteRuc: 0,
  clienteDv: 0,
  clienteDireccion: "Panama",
  clienteTelefono: "",

  fechaEmision: "2026-02-18",
  puntoFacturacion: "001",
  consultaClaveUrl: "https://dgi-fep.mef.gob.pa/Consultas/FacturasPorCUFE",
  cufe: "0",

  items: [
    { no: 1, descripcion: "Mini Fish", cantidad: 1, precioUnitario: 8.10, descuentoUnitario: 0.00, montoItbms: 0.00, valorItem: 8.10 },


  ],

  itbmsBreakdown: [
    { montoBase: 0.00, porcentaje: 0.00, impuesto: 0.00, label: "Total" }
  ],

  formaPagoMonto: 16.20,
  totalPagado: 16.20,
  vuelto: 0.00,
};

export default function Invoice() {
  return (
    <div style={{ padding: 16, background: "#f1f5f9", minHeight: "100vh" }}>
      <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 12 }}>
        <h3 style={{ margin: 0 }}>Factura PDF</h3>

        <PDFDownloadLink
          document={<InvoicePDF data={data} />}
          fileName={`${data.number}.pdf`}
          style={{
            marginLeft: "auto",
            background: "#111",
            color: "#fff",
            padding: "10px 14px",
            borderRadius: 12,
            textDecoration: "none",
            fontWeight: 800,
            fontSize: 13,
          }}
        >
          {({ loading }) => (loading ? "Generando..." : "Descargar PDF")}
        </PDFDownloadLink>
      </div>

      {/* 👇 Si esto no tiene altura, se ve “blanco” */}
      <div style={{ height: "80vh", background: "#fff", borderRadius: 14, overflow: "hidden" }}>
        <PDFViewer style={{ width: "100%", height: "100%" }} showToolbar>
          <InvoicePDF data={data} />
        </PDFViewer>
      </div>
    </div>
  );
}